import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";

// `prices` arrives sorted ascending by month, so the latest fetched month is always the last entry - every
// "current price" surface (Hero, Differences, FAQ, Trend) needs this same record.
export const getLatestPriceReport = (prices: IPriceReportAveragePrices[] | null): IPriceReportAveragePrices | null => {
    if (!prices || prices.length === 0) {
        return null;
    }

    return prices[prices.length - 1];
};
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";

// `prices` arrives sorted ascending by month, so the latest fetched month is always the last entry - every
// "current price" surface (Hero, Differences, FAQ, Trend) needs this same record.
export const getLatestPriceReport = (prices: IPriceReportAveragePrices[] | null): IPriceReportAveragePrices | null => {
    if (!prices || prices.length === 0) {
        return null;
    }

    return prices[prices.length - 1];
};
